<template>
  <div class="body">
    <!-- 头部图 -->
    <div class="first-box" style="position: relative" id="topBox">
      <div class="first-title">
        <span>数 字 赋 能 , 泽 润 未 来</span>
        <p>
          从代码到洞察，赋能每一个决策，泽润深耕软件解决方案，做您最可靠的数字化合伙人
        </p>
      </div>
      <div class="pic" style="">
        <div class="first-pictop">
         <div class="topCard-box">
          <div class="topCard">
            <div class="topCardIcon">
              <img
                src="@/assets/icons/全流程交付与上线实施.png"
                alt=""
                style="height: 30px"
              />
              <h3>全流程交付与上线实施</h3>
            </div>
            <div class="topCardText">基于业务需求专业团队全程陪跑执行</div>
          </div>
          <div class="topCard">
            <div class="topCardIcon">
              <img
                src="@/assets/icons/全方位安全保障.png"
                alt=""
                style="height: 30px"
              />
              <h3>全方位安全保障</h3>
            </div>
            <div class="topCardText">加密合规需求，保护云上数据安全</div>
          </div>
          <div class="topCard">
            <div class="topCardIcon">
              <img
                src="@/assets/icons/全维数字经营驱动.png"
                alt=""
                style="height: 30px"
              />
              <h3>全维数字经营驱动</h3>
            </div>
            <div class="topCardText">数字洞察力，效果为导向精准营销获客</div>
          </div>
          <div class="topCard">
            <div class="topCardIcon">
              <img
                src="@/assets/icons/全天品质服务.png"
                alt=""
                style="height: 30px"
              />
              <h3>全天品质服务</h3>
            </div>
            <div class="topCardText">7×24小时专业工程师团队支持</div>
          </div>
          </div>

        </div>
      </div>
    </div>
    <div class="last-box">
    <div class="second-box">
      <div class="second-section">
        <!-- 顶部标题 -->
        <div class="second-title">
          <h2>无需自建团队，成熟增长模型赋能企业降本增效</h2>
        </div>
        <!-- 中间图标区域 -->
        <div class="second-icon">
          <div class="icon-item">
            <img src="@/assets/icons/ROI为导向全流程落地帮扶.png" />
            <span>ROI为导向全流程落地帮扶</span>
          </div>
          <div class="icon-item">
            <img src="@/assets/icons/N+1管家陪伴式运作.png" />
            <span>N+1管家陪伴式运作</span>
          </div>
          <div class="icon-item">
            <img src="@/assets/icons/多数据源集成与整合能力.png" />
            <span>多数据源集成与整合能力</span>
          </div>
        </div>

        <!-- 数据指标区域 -->
        <div class="second-metrics">
          <div class="metric-card">
            <div class="metric-item">
              <div>
                <span class="metric-value">47%</span>
                <span class="metric-label">转化率</span>
              </div>
              <img src="@/assets/icons/上升.png" />
            </div>
          </div>
          <div class="metric-card">
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 0 30px;
              "
            >
              <div class="metric-item">
                <div>
                  <span class="metric-value">59%</span>
                  <span class="metric-label">GMV</span>
                </div>
                <img src="@/assets/icons/上升.png" />
              </div>
              <div class="metric-item">
                <div>
                  <span class="metric-value">52%</span>
                  <span class="metric-label">留存率</span>
                </div>
                <img src="@/assets/icons/上升.png" />
              </div>
            </div>
          </div>
          <div class="metric-card">
            <div class="metric-item">
              <div>
                <span class="metric-value">64%</span>
                <span class="metric-label">经营成本</span>
              </div>
              <img src="@/assets/icons/下降.png" />
            </div>
          </div>
        </div>

        <!-- 描述文字 -->
        <div class="second-description">
          <p>
            可复制的数字化模式，以数据流量为引擎，驱动品牌全域经营，全线增长
          </p>
        </div>

        <!-- 申请按钮 -->
        <div class="second-button">
          <el-button type="primary">免费申请试用，助力企业快速转型</el-button>
        </div>

        <!-- 数字化 -->
        <div class="second-bottom">
          <div class="bottom-title">
            <p>敏捷助力企业数字化，为万千中小企业量身定制</p>
          </div>
          <div class="bottom-tags">
            <div class="tag-item" :class="{'activeIcon': activeIcon==1}" @mouseenter="activeIcon=1" @mouseleave="activeIcon=0">
              <img src="@/assets/icons/快速搭建.png" />
              <span>快速搭建</span>
            </div>
            <div class="tag-item" :class="{'activeIcon': activeIcon==2}" @mouseenter="activeIcon=2" @mouseleave="activeIcon=0">
              <img src="@/assets/icons/平台集成.png" />
              <span>平台集成</span>
            </div>
            <div class="tag-item" :class="{'activeIcon': activeIcon==3}" @mouseenter="activeIcon=3" @mouseleave="activeIcon=0">
              <img src="@/assets/icons/角色赋能.png" />
              <span>角色赋能</span>
            </div>
            <div class="tag-item" :class="{'activeIcon': activeIcon==4}" @mouseenter="activeIcon=4" @mouseleave="activeIcon=0">
              <img src="@/assets/icons/数据安全.png" />
              <span>数据安全</span>
            </div>
          </div>
          <div class="bottom-content">
            <!-- <div class="content-icon">
              <img src="@/assets/icons/更快地创建您的业务应用.png" />
              <h4>更快地创建您的业务应用</h4>
            </div> -->
            <div class="content-text">
              <div class="text" :class="{'textActive':activeIcon==1}" @mouseenter="activeIcon=1" @mouseleave="activeIcon=0"><img v-show="activeIcon==1" src="@/assets/icons/更快地创建您的业务应用.png" /> 更快地创建您的业务应用</div>
              <div class="text" :class="{'textActive':activeIcon==2}" @mouseenter="activeIcon=2" @mouseleave="activeIcon=0"><img v-show="activeIcon==2" src="@/assets/icons/更快地创建您的业务应用.png" /> 从需求到复杂，一个工作台就够了</div>
              <div class="text" :class="{'textActive':activeIcon==3}" @mouseenter="activeIcon=3" @mouseleave="activeIcon=0"><img v-show="activeIcon==3" src="@/assets/icons/更快地创建您的业务应用.png" /> 满足企业不同角色数字化诉求</div>
              <div class="text" :class="{'textActive':activeIcon==4}" @mouseenter="activeIcon=4" @mouseleave="activeIcon=0"><img v-show="activeIcon==4" src="@/assets/icons/更快地创建您的业务应用.png" /> 完备的安全策略，全方位保护企业数据</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- third -->
    <div class="third-box">
      <p>数智化领域方案全景图</p>
      <div class="content">
        <img src="@/assets/bg/数智化领域方案全景图.png" alt="" />
      </div>
    </div>
    <div class="four-box">
      <div class="four-title">
        流量时代，每一个细节都可能引起裂变，泽润给你多元化方案
      </div>
      <div class="four-content" @mouseleave="isActive = true">
        <!-- 数字化营销解决方案 -->
        <div class="solution-box" @mouseenter="isActive = false">
          <div class="solution-header">
            <h3>数字化营销解决方案</h3>
            <p>链接客户与品牌，实现精准触达与转化，提示营销ROI</p>
          </div>
          <div class="solution-features">
            <div>全域触达</div>
            <div>品效合一</div>
            <div>商机预测</div>
            <div>智慧引流</div>
            <div>营销自动化</div>
          </div>
        </div>
        <!-- 数字化协作运营解决方案 -->
        <div
          class="solution-box"
          :class="{ active: isActive }"
          @mouseenter="isActive = false"
        >
          <div class="solution-header">
            <h3>数字化协作运营解决方案</h3>
            <p>提升内部效率，打破部门壁垒，实现流程自动化</p>
          </div>
          <div class="solution-features">
            <div>智能决策引擎</div>
            <div>任务协同</div>
            <div>数据互通</div>
            <div>组织赋能</div>
            <div>效率革命</div>
          </div>
        </div>
        <!-- 数字化决策解决方案 -->
        <div class="solution-box" @mouseenter="isActive = false">
          <div class="solution-header">
            <h3>数字化决策解决方案</h3>
            <p>将数据转化为洞察力，辅助战略决策，遇见商机未来</p>
          </div>
          <div class="solution-features">
            <div>数据掘金</div>
            <div>实时监测</div>
            <div>内部风控</div>
            <div>预见性分析</div>
            <div>产业链协同</div>
          </div>
        </div>
      </div>
    </div>
    <div class="five-box">
      <div class="five-container">
        <h2 class="five-title">选择泽润，选择一份保障</h2>
        <div class="five-features">
          <!-- 第一行 -->
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/丰富的行业经验.png" />
            </div>
            <h3>丰富的行业经验</h3>
            <p>
              多年研发经验，横跨不同行业类目，真实案例累计支撑，成熟的解决方案，交付有保障。
            </p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/强大的研发能力.png" />
            </div>
            <h3>强大的研发能力</h3>
            <p>
              专业的研发团队，互联网大厂经验，协作流畅，深耕微信生态，拥有多年专业的产品研发积累。
            </p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/高度的定制服务.png" />
            </div>
            <h3>高度的定制服务</h3>
            <p>深度商业模式分析，用户研究，运营现场调研，为客户量身定制。</p>
          </div>
          <!-- 第二行 -->
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/更快的交付.png" />
            </div>
            <h3>更快的交付</h3>
            <p>
              完善的项目管理体系，成熟的管理团队，只为项目保质保量如期交付。
            </p>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/专业的售后.png" />
            </div>
            <h3>专业的售后</h3>
            <p>
              专业客服7*24小时在线，多维度、多渠道技术支持，多对一技术指导。
            </p>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/更多的服务.png" />
            </div>
            <h3>更多的服务</h3>
            <p>
              一站式延展服务，涵盖运营培训，上线维护，软著申请营销推广，让你全程无忧。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="six-box">
      <div class="six-bottom">
        <h3>突破增长瓶颈，让数据流动起来，开启云上增长新空间！</h3>
        <p>
          泽润团队特别希望与您交流，分享给您我们是如何帮助行业头部市场拉动增长的
        </p>
        <!-- <div class="five-input-group">
        <input type="text" placeholder="您的电话号码" />
        <button type="button">免费咨询</button>
      </div> -->
      </div>
    </div>
</div>
    <BottomFooter />
  </div>
</template>

<script>
import BottomFooter from './bottom.vue'

export default {
  name: "First",
  components: {
    BottomFooter
  },
  props: {
    point: {
      type:String,
      default:''
    }
  },
  data () {
    return {
      isActive: true,
      activeIcon: 0,

  }
  },
  watch: {
    point: {
        handler(newVal) {
          if(newVal){
            this.getScoll(newVal)
                console.log('新新新',newVal);
            }
        },
        immediate: true
    }
  },
  mounted () {
  },

  methods: {
    // 滚动
    getScoll(point){
      this.$nextTick(() => {
        // 元素自身高度
        const height = document.getElementById(point).offsetHeight
        const scrollTop = (document.getElementById(point).offsetTop)-(height/2) // 获取需要滚动的距离
        document.documentElement.scrollTop = scrollTop 
      })
    }
    },
   
};
</script>

<style lang="less" scoped>
  
     .body{background-color: #000;
         font-family: 'PingFang SC !important';
        }


    
    .last-box{ margin: 0 auto;overflow: hidden;}
.first-box {
  position: relative;
  height: 75vh; /* 视口多高，它就多高 */
  min-height: 800px !important;
  min-height: 500px;
  background: url("../assets/bg/bg1.png") no-repeat;
  background-size: cover;

  background-position: center center;
  overflow: hidden;
  .first-title {
    color: #fff;
    // font-family: FontName;
    letter-spacing: 0.1em;
    // font-variation-settings: "opsz" auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-80%);
    span {
      font-size: 50px;
      font-weight: 500;
      line-height: 2;
    }
    p {
      font-size: 20px;
    }
  }
  .first-pictop {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #132155 0%, #233aa9 100%);
    .topCard-box{
        width: 1200px;
        display: flex;
        align-items: stretch;
        justify-content: center;
    .topCard {
        flex: 1;

      color: #fff;
      padding: 20px 10px;
      background: linear-gradient(90deg, #233aa9 0%, #132155 100%);
      :hover{
        transform: scale(1.1);
      }
      .topCardIcon {
        display: flex;
        align-items: center;
        padding-left: 10px;
        img {
          height: 30px;
          padding-right: 10px;
        }
    }
    .topCardText {
      font-size: 16px;
    }
    }
}
  }
}

.second-box {
  background-color: #000;
  color: #fff;
  padding: 80px 0;
  overflow: hidden;
  .second-section {
    width: 1200px;
    margin: 0 auto;
    // padding: 0 20px;
    .second-title {
      text-align: center;
      margin-bottom: 60px;
      h2 {
        font-size: 32px;
        font-weight: bold;
        line-height: 1.5;
      }
    }
    .second-icon {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 60px;
      margin-bottom: 80px;
      background: url("../assets/bg/增长曲线.png") no-repeat;
      background-size: 100% 100%;

      .icon-item {
        color: #fff;
        font-size: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0 40px;
        img {
          padding-top: 100px;
          height: 120px;
          object-fit: contain;
        }
      }
    }
    .second-metrics {
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 30px;
      margin-bottom: 40px;
      .metric-card {
        flex: 1;
        &:nth-child(2) {
          flex: 2;
        }
        text-align: center;
        padding: 30px;
        border-radius: 10px;
        border: 1px solid transparent;
        box-shadow: 0 0 16px 0 #0d80ee;
        background: linear-gradient(
          135deg,
          rgba(75, 185, 213, 0.2) 0%,
          rgba(59, 95, 227, 0.2) 100%
        );
        // 第一个卡片 - 紫色渐变
        &:nth-child(1) {
          background: linear-gradient(
            135deg,
            #0c0b1d 0%,
            rgba(68, 9, 145, 0.5) 100%
          );
          &:hover {
            background: linear-gradient(
              135deg,
              #0c0b1d 0%,
              rgba(162, 104, 238, 0.5) 100%
            );
          }
        }
        &:nth-child(2) {
          background: linear-gradient(135deg, #090c1d 0%, #060e41 100%);
          &:hover {
            background: linear-gradient(135deg, #090c1d 0%, #2541f5 100%);
          }
        }
        &:nth-child(3) {
          background: linear-gradient(135deg, #0a1416 0%, #08282c 100%);
          &:hover {
            background: linear-gradient(135deg, #0a1416 0%, #26bace 100%);
          }
        }
        .metric-item {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            padding-left: 10px;
          }
        }
        .metric-value {
          display: block;
          font-size: 48px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 10px;
        }
        .metric-label {
          font-size: 20px;
          color: #ccc;
        }
      }
    }
    .second-description {
      text-align: center;
      margin-bottom: 60px;
      p {
        font-size: 30px;
        font-weight: bold;
        color: #ccc;
        line-height: 1.6;
      }
    }
    .second-button {
      text-align: center;
      margin-bottom: 100px;

      .el-button {
        background: linear-gradient(
          to right,
          #1890ff 0%,
          /* 蓝   20 % */ #3ca0fd 20%,
          #3ca0fd 20%,
          /* 绿   30 % */ #87e2f1 40%,
          #87e2f1 40%,
          /* 紫   30 % */ #7177f6 80%,
          #7177f6 80%,
          /* 红   20 % */ #68b8eb 100%
        );
        font-size: 20px;
        font-weight: bold;
        padding: 15px 40px;
        border: none;
        border-radius: 50px;
        box-shadow: 0 8px 20px rgba(75, 185, 213, 0.3);
        &:hover {
          background: linear-gradient(90deg, #3b5fe3 0%, #4bb9d5 100%);
          box-shadow: 0 10px 25px rgba(75, 185, 213, 0.4);
        }
      }
    }
    .second-bottom {
        width: 100%;
      height: 660px;
      overflow: hidden;
      border-radius: 10px;
      background: url("../assets/bg/敏捷数字化.png") no-repeat;
      background-size: 100% 100%;
      .bottom-title {
        font-size: 30px;
        padding-top: 30px;
      }
      .bottom-tags {
        display: flex;
        width: 60%;
        margin: 0 auto;
        margin-bottom: 60px;
        .tag-item {
          font-size: 22px;
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 0 auto;
          padding: 12px 0px;
          img {
            width: 30px;
          }
        }
        .activeIcon {
          font-size: 24px;
          color: #4bb9d5;
          cursor: pointer;
          transform: scale(1.1);
          transition: all 1s ease;
           img {
            width: 50px;
          }
        }
      }
      .bottom-content {
        padding-left: 15%;
        .content-icon {
          color: #2c6bf3;
          display: flex;
          align-items: center;
          gap: 10px;
          img {
            width: 30px;
          }
        }
        .content-text {
          text-align: left;
          padding-left: 40px;
          line-height: 4.5;
        //   h4 {
        //     font-size: 24px;
        //     font-weight: bold;
        //     margin-bottom: 20px;
        //     color: #4bb9d5;
        //   }
          .text {
            display: table;//盒子宽度为内容宽度
            font-size: 20px;
            color: #ccc;
            margin-bottom: 15px;
            transition: all 0.3s ease;

          }
          .text:hover{
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #4bb9d5;
            cursor: pointer;
            // transition: all 0.3s ease;
          }
          .textActive {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #4bb9d5;
            // transition: all 0.3s ease;
          }
        }
      }
    }
  }
}

.third-box {
  color: #fff;
  font-size: 30px;
  padding-top: 30px;
  background-color: #252733;
  .content{
    width: 1200px;
    margin: 0 auto;
    
    img{
        width: 100%;
        margin: 30px 0 100px;
    }

  }
  
}
.four-box {
  position: relative;
  height: 535px;
  overflow: hidden;
  padding: 100px 0;
  background: url("../assets/bg/解决方案.png") no-repeat;
  background-color: #000;
  background-size: 100% 100%;

  .four-title {
    color: #ffffff;
    font-size: 30px;
    font-family: PingFang SC;
    font-variation-settings: "opsz" auto;
    margin-bottom: 100px;
  }
  .four-content {
    width: 1200px;
    
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 1200px;
    margin: 0 auto;
  }

  .solution-box {
    position: relative;
    width: 33.3%;
    color: #fff;
    z-index: 1;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid #2435b1;
    background: linear-gradient(135deg,rgba(66, 103, 178, 0.3) 0%,rgba(45, 52, 103, 0.5) 100%);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    transition: all 1s ease;
  }
  /* 默认中间盒子高亮 */
  .solution-box.active {
    color: #383c78;
    z-index: 999;
    transform: scale(1.08); // ③ 纯放大，不挤位置
    background: linear-gradient(135deg,rgba(255, 255, 255, 0.95) 0%,rgba(245, 247, 250, 0.98) 100%);
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
    .solution-header {
      height: 110px;
      color: #fff;
      background-color: #1994ff;
    }
  }
  /* 鼠标悬停效果 */
  .solution-box:hover {
    color: #383c78;
    z-index: 999;
    transform: scale(1.08); // ③ 纯放大，不挤位置
    background: linear-gradient(135deg,rgba(255, 255, 255, 0.95) 0%,rgba(245, 247, 250, 0.98) 100%);
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
    .solution-header {
      height: 110px;
      color: #fff;
      background-color: #1994ff;
    }
  }
  .solution-header {
    height: 100px;
    padding: 20px 5px;
    border-radius: 10px 10px 0 0;
    margin-bottom: 30px;
    background-color: #182b95;
  }
  .solution-header h3 {
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  .solution-header p {
    font-size: 16px;
    opacity: 0.8;
  }
  .solution-features {
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
  }
  .solution-features div {
    font-size: 20px;
    padding: 15px 0;
  }
}
.five-box {
  color: #fff;
  position: relative;
  padding: 50px 0 30;
  overflow: hidden;
  background-color: #000;
  margin-top: 50px;
  .five-container {
    width: 1200px;

    margin: 0 auto;
    padding: 0 20px;
    .five-title {
      font-size: 30px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 80px;
      color: #fff;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    }
    .five-features {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin-bottom: 100px;
    .feature-item {
            text-align: left;
            padding: 40px 30px;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 10px;
            transition: all 0.3s ease;
            border: 1px solid rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            &:nth-child(odd) {
                background: url("../assets/bg/toWhite.png") no-repeat;
                background-size: cover;
            }
            // 偶数（第 2、4、6... 个）
            &:nth-child(even) {
                background: url("../assets/bg/toBlack.png") no-repeat;
                background-size: cover;
            }
    
            h3 {
                font-size: 20px;
                font-weight: 500;
                margin-bottom: 15px;
                color: #fff;
            }
            p {
                font-family: Alibaba PuHuiTi 3;
                font-size: 18px;
                font-weight: 300;
                color: rgba(255, 255, 255, 0.7);
            }
            .feature-icon {
                width: 70px;
                height: 70px;
                // background: rgba(255, 255, 255, 0.1);
                // border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 25px;
                transition: all 0.3s ease;
    
                img {
                    // width: 40px;
                    // height: 40px;
                    // object-fit: contain;
                }
            }
        }
      .feature-item:hover {
        color: #fff;
        transform: translateY(-10px);
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
        border-color: rgba(241, 239, 239, 0.2);
        background: linear-gradient(135deg,rgba(15, 15, 15, 0.95) 0%,rgba(2, 67, 163, 0.98) 100%);
        .feature-icon {
        //   background: rgba(255, 255, 255, 0.2);
          transform: scale(1.1);
        }
        p {color: #fff;}
      }
    }
  }
}
.six-box {
  background-color: #000;
  .six-bottom {
    text-align: center;
    padding: 20px 0 100px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 15px;
    background: url("../assets/bg/突破增长瓶颈.png") no-repeat;
    background-size: 100% 100%;
    h3 {
      font-size: 30px;
      font-weight: 400;
      margin-bottom: 20px;
      color: #fff;
      line-height: 40px;
    }
    p {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 40px;
      line-height: 28px;
    }
  }
}



.five-input-group {
  display: flex;
  justify-content: center;
  gap: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.five-input-group input {
  flex: 1;
  padding: 18px 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  font-size: 16px;
  outline: none;
  transition: all 0.3s ease;
}

.five-input-group input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.five-input-group input:focus {
  border-color: #1994ff;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 0 3px rgba(25, 148, 255, 0.2);
}

.five-input-group button {
  padding: 18px 45px;
  background: linear-gradient(135deg, #1994ff 0%, #0f7ae5 100%);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(25, 148, 255, 0.3);
}

.five-input-group button:hover {
  background: linear-gradient(135deg, #0f7ae5 0%, #1994ff 100%);
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(25, 148, 255, 0.4);
}

</style>
